import { useQuery } from "@tanstack/react-query";
import { getPracticesDomains } from "../../../services/http.services";
import { EXPIRED_PRACTICES_QUERY_KEY } from "../../../config";
import { FormAutocomplete } from "../../../common/form-fields-wrappers";
import { ISearchExpiredPracticesForm, PracticesDomains } from "../../../models/models";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { useMemo } from "react";

interface SubstatusFilterProps {
    data: PracticesDomains | undefined,
    isLoading: boolean
}
const SubstatusFilter = ({
    data,
    isLoading
}: SubstatusFilterProps) => {

    const { t } = useTranslation('expiredManagement');
    
    const statusList = useWatch<ISearchExpiredPracticesForm, 'statuses'>({
        name: 'statuses'
    });

    const options = useMemo(() => {
        if (!data || !statusList) {
            return []
        };

        const substatuses = data?.substatuses;
        const result = substatuses?.filter(v => statusList.length === 0 || statusList.find(w => w.code === v.status));
        return result;
    }, [
        statusList,
        data
    ]);

    return (
        <FormAutocomplete<ISearchExpiredPracticesForm>
            name="substatuses"
            label={t('searchExpired.form.substatuses')}
            fullWidth
            options={options || []}
            loading={isLoading}
            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
            getOptionLabel={(opt: any) => opt?.label}
            multiple
        />
    )

}

export default SubstatusFilter;